import z from 'zod';

export const baseUploadSchema = z.object({
  relativePath: z.string().optional(),
});

export const uploadSchema = baseUploadSchema.extend({
  fileName: z.string(),
  contentType: z.string(),
});

export const deleteSchema = z.object({
  publicUrl: z.string(),
});

export const uploadResponseSchema = z.object({
  path: z.string(),
  publicUrl: z.string(),
  uploadUrl: z.string(),
});

export type UploadResponse = z.infer<typeof uploadResponseSchema>;
export type DeleteSchema = z.infer<typeof deleteSchema>;
